import React, { useRef, useState } from "react";
import Styles from "./Element.module.css";
import { useDispatch, useSelector } from "react-redux";
import Fileupload from "../../../../commons/Inputs/FileUpload/Fileupload";
import SelectInput from "../../../../commons/Inputs/Select/SelectInput";
import DateInput from "../../../../commons/Inputs/DateInput/DateInput";
import TextInput from "../../../../commons/Inputs/TextInput/TextInput";
import { Add, Close } from "@mui/icons-material";
import { verifyGeneratorName } from "../../../../Services/ApiCalling/Auth";
import { decryptData } from "../../../../commons/Decode";
import {
  publicCityById,
  publicDiscomByStateId,
  publicStateByRegionId,
} from "../../../../Redux/Slices/publicSlice";
import { ReactComponent as RemoveIcon } from "../../../../assets/images/Remove.svg";
import { toast } from "react-toastify";
import { toastProperties } from "../../../../commons/Toast/Toaster";

const AddressSection = ({
  prefix,
  addressData,
  handleChange,
  errors,
  publicData,
  index,
}) => {
  const dispatch = useDispatch();

  const handleGetCityByStateId = (index, field, value) => {
    dispatch(publicCityById(value?.id));
    handleChange(index, field, value);
  };

  const renderTextInput = (
    field,
    heading,
    example,
    type = "text",
    readOnly = false,
  ) => (
    <TextInput
      heading={`${heading} `}
      value={addressData[field]}
      onChange={(value) => handleChange(index, field, value)}
      example={example}
      type={type}
      height="45"
      error={errors[field]}
      readOnly={readOnly}
    />
  );

  const renderSelectInput = (field, heading, list, example) => (
    <SelectInput
      onChange={(value) =>
        heading === "State"
          ? handleGetCityByStateId(index, field, value)
          : handleChange(index, field, value)
      }
      list={list}
      value={addressData[field]}
      example={example}
      heading={`${heading} `}
      height="45px"
      error={errors[field]}
    />
  );

  return (
    <>
      <div className={Styles.layer1ElementsContainer}>
        {renderTextInput(`${prefix}_address`, "Full Address", `Enter Address`)}
      </div>
      <div className={Styles.layer3ElementsContainer}>
        {renderTextInput(`${prefix}_pincode`, "Pin Code", "Enter Pincode")}
        {renderSelectInput(
          `${prefix}_state`,
          "State",
          publicData?.stateUT,
          "Eg. Select State",
        )}
        {renderSelectInput(
          `${prefix}_city`,
          "City",
          publicData?.city,
          "Eg. Select City",
        )}
      </div>

      <div className={Styles.layer2ElementsContainer}>
        {renderTextInput(
          `${prefix}_contact`,
          "Name of the Contact Person",
          "Enter Contact Person Name",
        )}
        {renderTextInput(`${prefix}_email`, "Email", "Enter Email")}
      </div>
      <div className={Styles.layer2ElementsContainer}>
        {renderTextInput(`${prefix}_mobile`, "Mobile No.", "Enter Mobile No.")}
        {renderTextInput(
          `${prefix}_altMobile`,
          "Alternate Mobile No.",
          "Enter Alternate Mobile No.",
        )}
      </div>
    </>
  );
};

const GeneratorInputForm = ({ userData, handleData, handleProceed }) => {
  const dispatch = useDispatch();
  const [addressData, setAddressData] = useState({});
  const [sameCheck, setSameCheck] = useState("same");

  const publicData = useSelector((state) => state?.publicSlice);
  const createEmptyGeneratorDetail = () => {
    const defaultDetail = userData?.plantDetails?.[0] || {};
    return {
      plantName: defaultDetail.plantName || "",
      plant: defaultDetail.plant || "",
      plantDate: defaultDetail.plantDate || null,
      genType: defaultDetail.genType || "",
      genId: defaultDetail.genId || {},
      specification: defaultDetail.specification || {},
      installCap: defaultDetail.installCap || "",
      injectionCap: defaultDetail.injectionCap || "",
      identificationCode: defaultDetail.identificationCode || "",
      subsidy: defaultDetail.subsidy || "",
      subsidyType: defaultDetail.subsidyType || "",
      abt: defaultDetail.abt || "",
      controlArea: defaultDetail.controlArea || {},
      poi: defaultDetail.poi || "",
      poiLocation: defaultDetail.poiLocation || "",
      region: defaultDetail.region || {},
      state:
        defaultDetail.state && typeof defaultDetail.state === "object"
          ? defaultDetail.state
          : {},
      discom: defaultDetail.discom || [],
      discomName: defaultDetail.discomName || {},
      discomVoltage: defaultDetail.discomVoltage || [],
      voltage: defaultDetail.voltage || {},
      istsVoltage: defaultDetail.istsVoltage || [],
      stuVoltage: defaultDetail.stuVoltage || [],
      stateList: defaultDetail.stateList || [],
      discomList: defaultDetail.discomList || [],
      bankName:
        defaultDetail?.bankName || userData?.userCompany?.bankName || "",
      branchAddress:
        defaultDetail?.bankAddress || userData?.userCompany?.bankAddress || "",
      accountNumber:
        defaultDetail?.accountNo || userData?.userCompany?.accountNo || "",
      payee: defaultDetail?.payee || userData?.userCompany?.payee || "",
      ifscCode: defaultDetail?.ifsc || userData?.userCompany?.ifsc || "",
      bankDifferent: false,
      pan: defaultDetail?.pan || userData?.userCompany?.pan || "",
      gst: defaultDetail?.gst || userData?.userCompany?.gst || "",
      tan: defaultDetail?.tan || userData?.userCompany?.tan || "",
      panDocId: defaultDetail?.panDocId || userData?.documentList?.pan || "",
      gstDocId: defaultDetail?.gstDocId || userData?.documentList?.gst || "",
      tanDocId: defaultDetail?.tanDocId || userData?.documentList?.tan || "",
      registered_address: userData?.address?.[0]?.address || "",
      registered_state: userData?.address?.[0]?.state || {},
      registered_city: userData?.address?.[0]?.city || {},
      registered_pincode: userData?.address?.[0]?.pincode || "",
      registered_tel: userData?.address?.[0]?.tel || "",
      registered_email: userData?.address?.[0]?.email || "",
      registered_fax: userData?.address?.[0]?.fax || "",
      registered_contact: userData?.address?.[0]?.contact || "",
      registered_contactPhone: userData?.address?.[0]?.contactPhone || "",
      registered_mobile:
        userData?.address?.[0]?.mobile || userData?.phone || "",
      registered_altMobile:
        userData?.address?.[0]?.altMobile || userData?.phone || "",
      correspondence_address: userData?.address?.[1]?.address || "",
      correspondence_state: userData?.address?.[1]?.state || {},
      correspondence_city: userData?.address?.[1]?.city || {},
      correspondence_pincode: userData?.address?.[1]?.pincode || "",
      correspondence_tel: userData?.address?.[1]?.tel || "",
      correspondence_email: userData?.address?.[1]?.email || "",
      correspondence_fax: userData?.address?.[1]?.fax || "",
      correspondence_contact: userData?.address?.[1]?.contact || "",
      correspondence_contactPhone: userData?.address?.[1]?.contactPhone || "",
      correspondence_mobile:
        userData?.address?.[1]?.mobile || userData?.phone || "",
      correspondence_altMobile:
        userData?.address?.[1]?.altMobile || userData?.phone || "",
    };
  };

  const [errors, setErrors] = useState({});
  const [generatorDetails, setGeneratorDetails] = useState(
    userData?.plantDetails && userData.plantDetails.length > 0
      ? userData.plantDetails
      : [createEmptyGeneratorDetail()],
  );
  const [discomVoltage, setDiscomVoltage] = useState(() => {
    const plantDetailsLength = userData?.plantDetails?.length || 1;
    return Array(plantDetailsLength)
      .fill()
      .map(() => ({ discomId: {}, voltage: {} }));
  });

  const debounceTimeout = useRef(null);

  const validateFields = () => {
    const genErrors = {};
    generatorDetails.forEach((detail, index) => {
      const baseRequiredFields = [
        "plantName",
        "plant",
        "plantDate",
        "genType",
        "genId",
        "specification",
        "installCap",
        "injectionCap",
        "identificationCode",
        "subsidy",
        "subsidyType",
        "abt",
        "controlArea",
        "poi",
        "poiLocation",
        "region",
        "state",
      ];

      const installCapValue = Number(detail.installCap);
      const injectionCapValue = Number(detail.injectionCap);

      const requiredFields = detail.bankDifferent
        ? [
            ...baseRequiredFields,
            "bankName",
            "branchAddress",
            "accountNumber",
            "payee",
            "ifscCode",
          ]
        : baseRequiredFields;

      requiredFields.forEach((field) => {
        if (field === "plantDate") {
          if (
            !detail[field] ||
            !(detail[field] instanceof Date) ||
            isNaN(detail[field].getTime())
          ) {
            genErrors[`${field}_${index}`] = `${formatFieldName(
              field,
            )} is required`;
          }
        } else if (
          !detail[field] ||
          (typeof detail[field] === "object" && !detail[field]?.id)
        ) {
          genErrors[`${field}_${index}`] = `${formatFieldName(
            field,
          )} is required`;
        }
      });

      if (
        !detail.discom ||
        !Array.isArray(detail.discom) ||
        detail.discom.length === 0
      ) {
        genErrors[`discom_${index}`] =
          "At least one State-Discom-Voltage combination is required";
      } else {
        const getDiscomId = (obj) => obj?.id ?? obj?.discomId;
        const invalidCombinations = detail.discom.filter(
          (combo) =>
            !combo.state?.id ||
            !getDiscomId(combo.discomId) ||
            !combo.voltage?.id,
        );

        if (invalidCombinations.length > 0) {
          genErrors[`discom_${index}`] =
            "All discom combinations must have State, Discom, and Voltage selected";
        }
      }

      if (isNaN(installCapValue)) {
        genErrors[`installCap_${index}`] =
          "Installation Capacity must be a number";
      }

      if (isNaN(injectionCapValue)) {
        genErrors[`injectionCap_${index}`] =
          "Maximum Injection Capacity must be a number";
      }

      if (!isNaN(installCapValue) && !isNaN(injectionCapValue)) {
        if (injectionCapValue > installCapValue) {
          genErrors[`injectionCap_${index}`] =
            "Max injection ≤ installation capacity.";
        }
      }
    });

    setErrors(genErrors);
    return Object.keys(genErrors).length === 0;
  };

  const formatFieldName = (field) =>
    field.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());

  const handleChange = async (index, type, value) => {
    const updatedGeneratorDetails = [...generatorDetails];

    if (
      ["state", "region", "genId", "specification", "controlArea"].includes(
        type,
      )
    ) {
      updatedGeneratorDetails[index][type] =
        value && typeof value === "object" ? value : {};
    } else {
      updatedGeneratorDetails[index][type] = value;
    }

    const updatedErrors = { ...errors };

    if (type === "installCap" && !updatedGeneratorDetails[index].plantName) {
      updatedErrors[`plantName_${index}`] = "Generator Name is required.";
    } else {
      delete updatedErrors[`plantName_${index}`];
    }

    if (type === "plantName") {
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

      debounceTimeout.current = setTimeout(async () => {
        const currentName = updatedGeneratorDetails[index]?.plantName?.trim();
        if (currentName) {
          const response = await verifyGeneratorName(currentName);
          const decryptedData = decryptData(response?.data);

          setErrors((prevErrors) => {
            const newErrors = { ...prevErrors };
            if (decryptedData?.code !== 200) {
              newErrors[`plantName_${index}`] = decryptedData?.error;
            } else {
              delete newErrors[`plantName_${index}`];
            }
            return newErrors;
          });
        }
      }, 5000);
    }

    setErrors(updatedErrors);

    if (type === "state") {
      setDiscomVoltage((prev) => {
        const updated = [...prev];
        updated[index] = { discomId: {}, voltage: {} };
        return updated;
      });
    }

    setAddressData((prev) => {
      const updatedData = { ...prev, [type]: value };
      if (sameCheck === "same" && type.startsWith("registered_")) {
        const correspondenceField = type.replace(
          "registered_",
          "correspondence_",
        );
        updatedData[correspondenceField] = value;
      }
      return updatedData;
    });
    setGeneratorDetails(updatedGeneratorDetails);
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[`${type}_${index}`];
      if (type === "state") {
        delete newErrors[`discom_${index}`];
        delete newErrors[`voltage_${index}`];
      }
      return newErrors;
    });
  };

  const handleDiscomChange = (index, type, value) => {
    const updatedDiscomVoltage = [...discomVoltage];

    if (type === "discomId") {
      updatedDiscomVoltage[index] = {
        discomId: value,
        voltage: {},
      };
      handleChange(index, "discomName", value);

      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[`voltage_${index}`];
        return newErrors;
      });
    } else {
      updatedDiscomVoltage[index] = {
        ...updatedDiscomVoltage[index],
        [type]: value,
      };
    }

    setDiscomVoltage(updatedDiscomVoltage);

    if (type === "voltage" && value?.id) {
      const updatedGeneratorDetails = [...generatorDetails];
      const discomObject = {
        state: updatedGeneratorDetails[index]?.state,
        discomId: updatedDiscomVoltage[index]?.discomId,
        voltage: value,
      };

      const existingCombination = updatedGeneratorDetails[index].discom?.find(
        (item) =>
          item.state?.id === discomObject.state?.id &&
          item.discomId?.id === discomObject.discomId?.id &&
          item.voltage?.id === discomObject.voltage?.id,
      );

      const duplicateVoltageForDiscom = updatedGeneratorDetails[
        index
      ].discom?.find(
        (item) =>
          item.discomId?.id === discomObject.discomId?.id &&
          item.voltage?.id === discomObject.voltage?.id,
      );

      if (existingCombination) {
        return;
      }

      if (duplicateVoltageForDiscom) {
        toast.error(
          `Voltage level "${value.level}" is already selected for this DISCOM`,
          toastProperties,
        );
        return;
      }

      updatedGeneratorDetails[index].discom = [
        ...(Array.isArray(updatedGeneratorDetails[index].discom)
          ? updatedGeneratorDetails[index].discom
          : []),
        discomObject,
      ];

      updatedDiscomVoltage[index] = {
        discomId: updatedDiscomVoltage[index]?.discomId,
        voltage: {},
      };
      setDiscomVoltage(updatedDiscomVoltage);
      setGeneratorDetails(updatedGeneratorDetails);

      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[`voltage_${index}`];
        return newErrors;
      });
    }
  };

  const handleAddUser = () => {
    const lastGenerator =
      generatorDetails[generatorDetails.length - 1] ||
      createEmptyGeneratorDetail();

    const newGenerator = { ...lastGenerator };
    setGeneratorDetails((prev) => {
      const updated = [...prev, newGenerator];
      handleData("plantDetails", updated);
      return updated;
    });
    setDiscomVoltage((prev) => {
      const lastDiscomVoltage = prev[prev.length - 1] || {
        discomId: {},
        voltage: {},
      };
      return [...prev, { ...lastDiscomVoltage }];
    });
  };

  const handleRemoveUser = (index) => {
    if (generatorDetails.length > 1) {
      const updatedDetails = generatorDetails.filter((_, i) => i !== index);
      const updatedDiscomVoltage = discomVoltage.filter((_, i) => i !== index);

      setGeneratorDetails(updatedDetails);
      setDiscomVoltage(updatedDiscomVoltage);
      handleData("plantDetails", updatedDetails);

      const updatedErrors = { ...errors };
      Object.keys(updatedErrors).forEach((key) => {
        if (key.endsWith(`_${index}`)) {
          delete updatedErrors[key];
        }

        if (key.includes("_") && parseInt(key.split("_").pop()) > index) {
          const newKey = key.replace(
            /_\d+$/,
            `_${parseInt(key.split("_").pop()) - 1}`,
          );
          updatedErrors[newKey] = updatedErrors[key];
          delete updatedErrors[key];
        }
      });
      setErrors(updatedErrors);
    }
  };

  React.useEffect(() => {
    if (
      userData?.plantDetails &&
      Array.isArray(userData.plantDetails) &&
      userData.plantDetails.length > 0
    ) {
      setGeneratorDetails(userData.plantDetails);
    }
  }, [userData?.plantDetails]);

  React.useEffect(() => {
    if (discomVoltage.length !== generatorDetails.length) {
      const newDiscomVoltage = Array(generatorDetails.length)
        .fill()
        .map((_, i) => discomVoltage[i] || { discomId: {}, voltage: {} });
      setDiscomVoltage(newDiscomVoltage);
    }
  }, [generatorDetails.length, discomVoltage]);

  const handleContinue = async (data) => {
    const isValid = await validateFields();
    if (!isValid) return;

    handleData("plantDetails", generatorDetails);
    handleProceed(data);
  };

  const handleGetStateByRegionId = (id) => {
    dispatch(publicStateByRegionId(id?.id));
  };
  const handleGetDiscomByStateId = (id) => {
    dispatch(publicDiscomByStateId(id?.id));
  };

  const handleFieldChange = (index, field, value) => {
    const updatedDetails = [...generatorDetails];
    updatedDetails[index][field] = value;
    setGeneratorDetails(updatedDetails);

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[`${field}_${index}`];
      return newErrors;
    });

    handleData("plantDetails", updatedDetails);
  };

  const renderTextInput = (
    index,
    field,
    heading,
    example,
    type = "text",
    readOnly = false,
  ) => (
    <TextInput
      heading={`${heading} `}
      value={generatorDetails[index][field]}
      onChange={(value) => handleChange(index, field, value)}
      example={example}
      type={type}
      height="45"
      error={errors[`${field}_${index}`]}
      readOnly={readOnly}
    />
  );

  const renderSelectInput = (
    index,
    type,
    list,
    example,
    heading,
    recurring,
  ) => {
    const isDisabled = () => {
      if (recurring === "discom") {
        if (type === "discomId") {
          const hasStateSelected = generatorDetails[index]?.state?.id;
          const hasExistingCombinations =
            generatorDetails[index]?.discom?.length > 0;
          return !hasStateSelected && !hasExistingCombinations;
        }
        if (type === "voltage") {
          if (!discomVoltage[index]) {
            return true;
          }

          const discomSelected = discomVoltage[index].discomId;

          const hasValidDiscom =
            discomSelected &&
            (discomSelected.id ||
              discomSelected.name ||
              discomSelected.acronym ||
              (typeof discomSelected === "string" &&
                discomSelected.trim() !== "") ||
              (typeof discomSelected === "object" &&
                Object.keys(discomSelected).length > 0 &&
                !Array.isArray(discomSelected)));

          return !hasValidDiscom;
        }
      }
      return false;
    };

    return (
      <SelectInput
        onChange={(value) =>
          recurring === "discom"
            ? handleDiscomChange(index, type, value)
            : handleChange(
                index,
                type,
                value,
                type === "region"
                  ? handleGetStateByRegionId(value)
                  : type === "state"
                    ? handleGetDiscomByStateId(value)
                    : null,
              )
        }
        list={list}
        value={
          recurring === "discom"
            ? discomVoltage[index]?.[type] || {}
            : generatorDetails[index][type]
        }
        example={example}
        heading={`${heading} `}
        height="45px"
        error={errors[`${type}_${index}`]}
        disabled={isDisabled()}
      />
    );
  };

  const renderFileUpload = (index, heading, field, example, type, ID) => (
    <Fileupload
      heading={heading}
      value={generatorDetails[index][field]}
      onChange={(value) => handleFieldChange(index, field, value)}
      height="45"
      example={example}
      type={type}
      id={ID}
      error={errors[`${field}_${index}`]}
    />
  );

  const renderCheckbox = (index, field, options, heading) => (
    <div className={Styles.checkBoxElem}>
      <div className={Styles.checkBoxHead}>{heading}</div>
      <div
        className={`${Styles.selectCheckElemEent} ${Styles.checkboxGenerator}`}
      >
        {(Array.isArray(options) ? options : []).map((option) => (
          <div
            key={option.value}
            onClick={() => handleChange(index, field, option.value)}
            style={{ width: `${100 / options.length}%` }}
            className={
              generatorDetails[index][field] === option.value
                ? Styles.activeCheck
                : Styles.inactiveCheck
            }
          >
            {option.label}
          </div>
        ))}
      </div>
      {errors[`${field}_${index}`] && (
        <span className={Styles.errorPass}>{errors[`${field}_${index}`]}</span>
      )}
    </div>
  );

  const renderDateInput = (index, field) => (
    <DateInput
      heading={
        generatorDetails[index].plant === "commissioned"
          ? "Date of commission *"
          : "Date to be commission *"
      }
      value={generatorDetails[index][field]}
      onChange={(value) => handleChange(index, field, value)}
      height="45"
      error={errors[`${field}_${index}`]}
    />
  );

  const controlAreaOptions =
    publicData?.controlArea?.map((item) =>
      typeof item === "string" ? { id: item, name: item } : item,
    ) || [];

  const renderInputFields = (index) => (
    <>
      <div className={Styles.layer3ElementsContainer}>
        {renderTextInput(
          index,
          "plantName",
          "Generator Name",
          "Eg. GNA Energy",
        )}
        {renderTextInput(
          index,
          "installCap",
          "Installed Capacity (In MW)",
          "number",
          "Eg. 100000",
        )}
        {renderTextInput(
          index,
          "injectionCap",
          "Maximum Injection Capacity (MW)",
          "Eg. 100000",
          "number",
        )}
      </div>
      <div className={Styles.layer3ElementsContainer}>
        {renderSelectInput(
          index,
          "specification",
          publicData?.specification?.filter((ele) => ele?.type === "GENERATOR"),
          "Select Plant Specification",
          "Plant Specification",
        )}

        {renderCheckbox(
          index,
          "plant",
          [
            { value: "commissioned", label: "Commissioned" },
            { value: "notcommissioned", label: "To Be Commissioned" },
          ],
          "Plant",
        )}

        {renderDateInput(index, "plantDate")}
      </div>
      <div className={Styles.layer3ElementsContainer}>
        {renderCheckbox(
          index,
          "genType",
          [
            { value: "RENEWABLE", label: "Renewable" },
            { value: "NON_RENEWABLE", label: "Non Renewable" },
          ],
          "Generating Type",
        )}
        {renderSelectInput(
          index,
          "genId",
          publicData?.publicEnergyType?.filter(
            (ele) => ele?.genType === generatorDetails[index].genType,
          ),
          "Select Energy Type",
          "Energy Type",
        )}
        {renderTextInput(
          index,
          "identificationCode",
          "Unique Project Identification Code",
          "Eg. GNA2025",
        )}
      </div>
      <div className={Styles.layer3ElementsContainer}>
        {renderCheckbox(
          index,
          "subsidy",
          [
            { value: "NO", label: "No" },
            { value: "YES", label: "Yes" },
          ],
          "Subsidy Received",
        )}
        {renderTextInput(
          index,
          "subsidyType",
          "Subsidy Type",
          "Enter Subsidy Type",
        )}
        {renderCheckbox(
          index,
          "abt",
          [
            { value: "EXISTS", label: "Exists" },
            { value: "NON_EXISTS", label: "To Be Arranged" },
          ],
          "ABT Metering Arrangement",
        )}
      </div>
      <div className={Styles.layer3ElementsContainer}>
        {renderSelectInput(
          index,
          "controlArea",
          controlAreaOptions,
          "Eg. Select Control Area",
          "Control Area",
        )}
        {renderTextInput(
          index,
          "poiLocation",
          "Name of Location of POI",
          "Enter POI",
        )}
        {renderSelectInput(
          index,
          "region",
          publicData?.region,
          "Select Region",
          "Region",
        )}
      </div>
      <div className={Styles.layer3ElementsContainer}>
        <div className={Styles.checkBoxElem}>
          <div className={Styles.checkBoxHead}>Point Of Injection (POI)*</div>
          <div className={Styles.selectCheckElemEent}>
            {["ISTS", "STU", "DISCOM"].map((poiType) => (
              <div
                key={poiType}
                onClick={() => handleChange(index, "poi", poiType)}
                style={{ width: "30%" }}
                className={
                  generatorDetails[index].poi === poiType
                    ? Styles.activeCheck
                    : Styles.inactiveCheck
                }
              >
                {poiType}
              </div>
            ))}
          </div>
          {errors[`poi_${index}`] && (
            <span className={Styles.errorPass}>{errors[`poi_${index}`]}</span>
          )}
        </div>

        {/* Voltage Selection */}
        <div>
          {(generatorDetails[index].poi === "ISTS" ||
            generatorDetails[index].poi === "STU") && (
            <SelectInput
              onChange={(value) => {
                const updatedVoltages = [...generatorDetails];
                const voltageType = `${generatorDetails[
                  index
                ].poi.toLowerCase()}Voltage`;

                const currentVoltages =
                  updatedVoltages[index][voltageType] || [];

                const isAlreadySelected = currentVoltages.some(
                  (v) => (v?.id || v) === (value?.id || value),
                );

                if (isAlreadySelected) {
                  updatedVoltages[index][voltageType] = currentVoltages.filter(
                    (v) => (v?.id || v) !== (value?.id || value),
                  );
                } else {
                  updatedVoltages[index][voltageType] = [
                    ...currentVoltages,
                    value,
                  ];
                }

                setGeneratorDetails(updatedVoltages);
              }}
              list={publicData?.voltage}
              value={{}}
              example={"Select Voltage Levels"}
              heading={`${generatorDetails[index].poi} Voltage`}
              height={"45px"}
              multiple
            />
          )}
        </div>

        {/* Voltage Display */}
        {(generatorDetails[index].poi === "ISTS" ||
          generatorDetails[index].poi === "STU") && (
          <div className={Styles.layerscrollElements}>
            {(Array.isArray(
              generatorDetails[index][
                `${generatorDetails[index].poi.toLowerCase()}Voltage`
              ],
            )
              ? generatorDetails[index][
                  `${generatorDetails[index].poi.toLowerCase()}Voltage`
                ]
              : []
            )?.map((ele, voltageIndex) => (
              <div key={voltageIndex} className={Styles.eachLevelLayer}>
                <span>{ele?.level || ele}</span>
                <Close
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  onClick={() => {
                    const updatedVoltages = [...generatorDetails];
                    const voltageType = `${generatorDetails[
                      index
                    ].poi.toLowerCase()}Voltage`;
                    updatedVoltages[index][voltageType] = updatedVoltages[
                      index
                    ][voltageType].filter((_, i) => i !== voltageIndex);
                    setGeneratorDetails(updatedVoltages);
                  }}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      <div className={Styles.divider}></div>

      {/* Discom Selection */}
      <div className={Styles.discomSelectionContainer}>
        <div className={Styles.subConterntHeader}>Discom Voltage</div>
        <div className={Styles.layer3ElementsContainer}>
          {renderSelectInput(
            index,
            "state",
            publicData?.stateUT,
            "Select State",
            "State",
          )}
          {renderSelectInput(
            index,
            "discomId",
            publicData?.discom,
            "Select Discom",
            "Discom",
            "discom",
          )}
          {renderSelectInput(
            index,
            "voltage",
            publicData?.voltage,
            "Select Voltage Level",
            "Voltage Level",
            "discom",
          )}
        </div>

        {/* Clear current discom selection button */}
        {discomVoltage[index]?.discomId?.id && (
          <div
            style={{
              marginTop: "10px",
              marginBottom: "10px",
              textAlign: "center",
            }}
          >
            <button
              type="button"
              onClick={() => {
                const updatedDiscomVoltage = [...discomVoltage];
                updatedDiscomVoltage[index] = { discomId: {}, voltage: {} };
                setDiscomVoltage(updatedDiscomVoltage);
              }}
              style={{
                padding: "8px 16px",
                fontSize: "13px",
                backgroundColor: "#fff",
                border: "1px solid #ddd",
                borderRadius: "6px",
                cursor: "pointer",
                color: "#666",
                fontWeight: "500",
                transition: "all 0.2s ease",
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#f8f9fa";
                e.target.style.borderColor = "#bbb";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "#fff";
                e.target.style.borderColor = "#ddd";
              }}
            >
              Change Discom Selection
            </button>
          </div>
        )}

        <div className={Styles.voltageOverflow}>
          {generatorDetails[index]?.discom?.map((ele, discomIndex) => (
            <div key={discomIndex} className={Styles.voltageSection}>
              <div className={Styles.actVoltageLevel}>
                <div>{ele?.voltage?.level}</div>
                <Close
                  style={{
                    fontSize: "12px",
                    color: "red",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    const updatedGeneratorDetails = [...generatorDetails];
                    updatedGeneratorDetails[index].discom =
                      updatedGeneratorDetails[index].discom.filter(
                        (_, i) => i !== discomIndex,
                      );
                    setGeneratorDetails(updatedGeneratorDetails);
                  }}
                />
              </div>
              <div className={Styles.discomName}>
                {/* <div style={{ fontSize: "11px", color: "#666" }}>
                  {ele?.state?.name || ele?.state?.acronym}
                </div> */}
                <div>{ele?.discomId?.acronym}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );

  return (
    <div className={Styles.elementMain}>
      <div className={Styles.displayInputSection}>
        <div className={`${Styles.conterntHeader} ${Styles.contentHeadGen}`}>
          <span className={Styles.genHeading}>Generator Details</span>
          <div className={Styles.noteContainer}>
            <b>Note:</b>
            <span>You can Create multiple Generators</span>
          </div>
        </div>
        <div className={Styles.detailsInpMainContainer}>
          {generatorDetails.map((_, index) => (
            <div className={Styles.multiLayerContainer} key={index}>
              <div
                className={`${Styles.alterSection} ${Styles.alterSectionOther}`}
              >
                {generatorDetails.length > 1 && (
                  <div
                    className={Styles.deleteSection}
                    onClick={() => handleRemoveUser(index)}
                  >
                    <RemoveIcon style={{ fontSize: "16px" }} />
                  </div>
                )}
                <div
                  className={`${Styles.addSection} ${Styles.AddnewGenSection}`}
                  onClick={handleAddUser}
                >
                  <Add style={{ fontSize: "14px" }} />
                  <span className={Styles.addNewHeading}>
                    Add New Generator
                  </span>
                </div>
              </div>
              {renderInputFields(index)}
              <div className={Styles.corrAddressContainer}>
                <div
                  className={`${Styles.subConterntHeader} ${Styles.corrOtherHeading}`}
                >
                  Bank Details
                </div>
                <div className={Styles.corrAddSelection}>
                  <div className={Styles.officeSelectionText}>
                    <div>
                      Same as the <b>Company</b> bank details
                    </div>
                    <div className={Styles.sel_button}>
                      <span
                        onClick={() =>
                          handleChange(index, "bankDifferent", false)
                        }
                        className={
                          !generatorDetails[index].bankDifferent
                            ? Styles.active_corr
                            : Styles.inAct_corr
                        }
                      >
                        Yes
                      </span>
                      <span
                        onClick={() =>
                          handleChange(index, "bankDifferent", true)
                        }
                        className={
                          generatorDetails[index].bankDifferent
                            ? Styles.active_corr
                            : Styles.inAct_corr
                        }
                      >
                        No
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={Styles.divider}></div>
              {generatorDetails[index].bankDifferent && (
                <>
                  <div className={Styles.layer2ElementsContainer}>
                    {renderTextInput(
                      index,
                      "bankName",
                      "Bank Name",
                      "Eg. State Bank of India",
                    )}
                    {renderTextInput(
                      index,
                      "branchAddress",
                      "Bank Address",
                      "Eg. 123 Main Street, City",
                    )}
                  </div>
                  <div className={Styles.layer3ElementsContainer}>
                    {renderTextInput(
                      index,
                      "accountNumber",
                      "Account Number",
                      "Eg. 1234567890",
                      "number",
                    )}
                    {renderTextInput(
                      index,
                      "payee",
                      "Payee Name",
                      "Eg. John Doe",
                    )}
                    {renderTextInput(
                      index,
                      "ifscCode",
                      "IFSC Code",
                      "Eg. SBIN0001234",
                    )}
                  </div>
                  <div className={Styles.layer3ElementsContainer}>
                    {renderTextInput(
                      index,
                      "gst",
                      "GST Number",
                      "Eg. 123456789012345",
                    )}
                    {renderTextInput(
                      index,
                      "pan",
                      "PAN Number",
                      "Eg. ABCDE1234F",
                    )}
                    {renderTextInput(
                      index,
                      "tan",
                      "TAN Number",
                      "Eg. ABCDE1234F",
                    )}
                  </div>
                  <div className={Styles.layer3ElementsContainer}>
                    {renderFileUpload(
                      index,
                      "GST Certificate Copy",
                      "gstDocId",
                      "Upload GST (.pdf accepted)",
                      "GST",
                      "gstDocId",
                    )}
                    {renderFileUpload(
                      index,
                      "PAN Card Copy",
                      "panDocId",
                      "Upload PAN (.pdf accepted)",
                      "PAN",
                      "panDocId",
                    )}
                    {renderFileUpload(
                      index,
                      "TAN Card Copy",
                      "tanDocId",
                      "Upload TAN (.pdf accepted)",
                      "TAN",
                      "tanDocId",
                    )}
                  </div>
                </>
              )}

              <div className={Styles.conAddressContainer}>
                <div
                  className={`${Styles.subConterntHeader} ${Styles.corrOtherHeading}`}
                >
                  Registered Address
                </div>
                <div className={Styles.divider}></div>
                <AddressSection
                  prefix="registered"
                  addressData={generatorDetails[index]}
                  handleChange={handleChange}
                  errors={errors}
                  publicData={publicData}
                  index={index}
                />
                <div className={Styles.divider}></div>
                <div className={Styles.corrAddressContainer}>
                  <div
                    className={`${Styles.subConterntHeader} ${Styles.corrOtherHeading}`}
                  >
                    Correspondence Address
                  </div>
                  <div className={Styles.corrAddSelection}>
                    <div className={Styles.officeSelectionText}>
                      <div>Same as that of Office Address</div>
                      <div className={Styles.sel_button}>
                        <span
                          onClick={() => setSameCheck("same")}
                          className={
                            sameCheck === "same"
                              ? Styles.active_corr
                              : Styles.inAct_corr
                          }
                        >
                          Yes
                        </span>
                        <span
                          onClick={() => setSameCheck("different")}
                          className={
                            sameCheck === "different"
                              ? Styles.active_corr
                              : Styles.inAct_corr
                          }
                        >
                          No
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={Styles.divider}></div>
                {sameCheck === "different" && (
                  <AddressSection
                    prefix="correspondence"
                    addressData={generatorDetails[index]}
                    handleChange={handleChange}
                    errors={errors}
                    publicData={publicData}
                    index={index}
                  />
                )}
              </div>

              {(generatorDetails.length === 0 ||
                generatorDetails.length === 1) && (
                <div className={Styles.AddMoreCont} onClick={handleAddUser}>
                  <Add style={{ fontSize: "14px" }} />
                  <span>Add New Generator</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className={Styles.buttonSection}>
        <div className={Styles.prevBtn} onClick={() => handleProceed("prev")}>
          Back
        </div>
        <div className={Styles.nextBtn} onClick={() => handleContinue("next")}>
          Next
        </div>
      </div>
    </div>
  );
};

export default GeneratorInputForm;
